import makeInitialState from 'client/makeInitialState';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_CLICKED_NON_MATCHED_HOMES } from 'client/analytics/eventList';

export default async function enableAllListings({ state }) {
  const listingsState = state.get(['listings']);
  const initialState = makeInitialState();

  state.set('listings', {
    ...initialState.listings,
    records: listingsState.records,
    viewMoreIndex: listingsState.total,
    totalListingsCount: listingsState.totalListingsCount,
    enableAllListings: true,
  });

  state.commit();

  analytics.track(ANALYTICS_EVENT_CLICKED_NON_MATCHED_HOMES);
}
